import { ScoringPage } from "./ScoringPage";

const pages = {
  ScoringPage,
};
export default pages;
